/**
 * Otomasyon yetkilendirme scope'ları ve bağımlılıkları
 */

export const AUTOMATION_PERMISSION_SCOPES = {
    // Temel Yetkiler
    AUTOMATION_READ: "automation-read",
    
    // Flow Yetkileri
    AUTOMATION_FLOW_UPDATE: "automation-flow-update",
    
    // Meta Yetkileri
    AUTOMATION_META_UPDATE: "automation-meta-update",
    
    // Yayın Yetkileri
    AUTOMATION_PUBLISH: "automation-publish",
    
    // Silme Yetkisi
    AUTOMATION_DELETE: "automation-delete",
    
    // Kopyalama Yetkisi
    AUTOMATION_DUPLICATE: "automation-duplicate",
    
    // Plan Yetkileri
    AUTOMATION_PLAN_VIEW: "automation-plan-view",
    AUTOMATION_PLAN_CANCEL: "automation-plan-cancel",
    AUTOMATION_RESCHEDULE: "automation-reschedule",
    
    // Filtre Yapılandırma
    AUTOMATION_PREFILTER_UPDATE: "automation-prefilter-update",
};

/**
 * Her scope için bağımlılıkları tanımlar
 * Bir scope'a sahip olabilmek için bağımlı scope'lara da sahip olunmalıdır
 */
export const AUTOMATION_PERMISSION_DEPENDENCIES = {
    // Temel yetkiler
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ]: [],
    
    // Flow yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_FLOW_UPDATE]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
    
    // Meta yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_META_UPDATE]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
    
    // Yayın yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PUBLISH]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
    
    // Silme yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_DELETE]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
    
    // Kopyalama yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_DUPLICATE]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
    
    // Plan görme yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_VIEW]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
    
    // Plan iptal yetkisi - read ve plan-view'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_CANCEL]: [
        AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ,
        AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_VIEW,
    ],
    
    // Yeniden planlama yetkisi - read ve plan-view'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_RESCHEDULE]: [
        AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ,
        AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_VIEW,
    ],
    
    // Prefilter yetkisi - read'e bağımlı
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PREFILTER_UPDATE]: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
};

/**
 * Scope grupları - UI'da gruplandırma için
 */
export const AUTOMATION_SCOPE_GROUPS = {
    BASIC: {
        id: "basic",
        titleKey: "automation.permissions.groups.basic",
        scopes: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ],
        icon: "visibility",
    },
    FLOW: {
        id: "flow",
        titleKey: "automation.permissions.groups.flow",
        scopes: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_FLOW_UPDATE],
        icon: "account_tree",
    },
    META: {
        id: "meta",
        titleKey: "automation.permissions.groups.meta",
        scopes: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_META_UPDATE],
        icon: "edit",
    },
    PUBLISH: {
        id: "publish",
        titleKey: "automation.permissions.groups.publish",
        scopes: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PUBLISH],
        icon: "publish",
    },
    ACTIONS: {
        id: "actions",
        titleKey: "automation.permissions.groups.actions",
        scopes: [
            AUTOMATION_PERMISSION_SCOPES.AUTOMATION_DELETE,
            AUTOMATION_PERMISSION_SCOPES.AUTOMATION_DUPLICATE,
        ],
        icon: "settings",
    },
    PLAN: {
        id: "plan",
        titleKey: "automation.permissions.groups.plan",
        scopes: [
            AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_VIEW,
            AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_CANCEL,
            AUTOMATION_PERMISSION_SCOPES.AUTOMATION_RESCHEDULE,
        ],
        icon: "schedule",
    },
    FILTER: {
        id: "filter",
        titleKey: "automation.permissions.groups.filter",
        scopes: [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PREFILTER_UPDATE],
        icon: "filter_alt",
    },
};

/**
 * Scope açıklamaları - UI'da gösterilmek üzere
 */
export const AUTOMATION_SCOPE_LABELS = {
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_READ]: {
        labelKey: "automation.permissions.scopes.read",
        descriptionKey: "automation.permissions.scopes.readDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_FLOW_UPDATE]: {
        labelKey: "automation.permissions.scopes.flowUpdate",
        descriptionKey: "automation.permissions.scopes.flowUpdateDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_META_UPDATE]: {
        labelKey: "automation.permissions.scopes.metaUpdate",
        descriptionKey: "automation.permissions.scopes.metaUpdateDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PUBLISH]: {
        labelKey: "automation.permissions.scopes.publish",
        descriptionKey: "automation.permissions.scopes.publishDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_DELETE]: {
        labelKey: "automation.permissions.scopes.delete",
        descriptionKey: "automation.permissions.scopes.deleteDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_DUPLICATE]: {
        labelKey: "automation.permissions.scopes.duplicate",
        descriptionKey: "automation.permissions.scopes.duplicateDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_VIEW]: {
        labelKey: "automation.permissions.scopes.planView",
        descriptionKey: "automation.permissions.scopes.planViewDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PLAN_CANCEL]: {
        labelKey: "automation.permissions.scopes.planCancel",
        descriptionKey: "automation.permissions.scopes.planCancelDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_RESCHEDULE]: {
        labelKey: "automation.permissions.scopes.reschedule",
        descriptionKey: "automation.permissions.scopes.rescheduleDesc",
    },
    [AUTOMATION_PERMISSION_SCOPES.AUTOMATION_PREFILTER_UPDATE]: {
        labelKey: "automation.permissions.scopes.prefilterUpdate",
        descriptionKey: "automation.permissions.scopes.prefilterUpdateDesc",
    },
};

/**
 * Tüm scope'ları sıralı olarak döndürür
 */
export function getAllAutomationScopes() {
    return Object.values(AUTOMATION_PERMISSION_SCOPES);
}

/**
 * Belirli bir grup için scope'ları döndürür
 */
export function getAutomationScopesByGroup(groupId) {
    var group = Object.values(AUTOMATION_SCOPE_GROUPS).find(function(g) {
        return g.id === groupId;
    });
    return group ? group.scopes : [];
}

/**
 * Bir scope'un bağımlılıklarını döndürür
 */
export function getAutomationScopeDependencies(scope) {
    return AUTOMATION_PERMISSION_DEPENDENCIES[scope] || [];
}

/**
 * Bir scope'un label ve description key'lerini döndürür
 */
export function getAutomationScopeLabel(scope) {
    return AUTOMATION_SCOPE_LABELS[scope] || { labelKey: scope, descriptionKey: scope };
}
